export default __webpack_public_path__ + "static/media/exploded-view_sprite.a1566311.png";